import { connect } from 'react-redux';

import { getOrganizationMembersList } from '../../Projects/projectsActions';
import {
  editSubTask,
  getTaskDetails,
  getTaskType,
  removeTaskAssignee,
  updatePartialTask,
  updateTaskApproval,
  updateTaskAssignee,
  getTaskHistory,
  reassignAssignee,
} from '../tasksActions';
// Component
import TaskDetails from './TaskDetails';

// Store props to map with current state
const mapStateToProps = state => ({
  memberShortListIsLoading: state.project.memberShortListIsLoading,
  reassignAssigneeLoading: state.task.reassignAssigneeLoading,
  selectedOrganization: state.organization.selectedOrganization,
  orgMembersList: state.project.orgMembersList,
  isLoading: state.task.isLoading,
  taskDetailsLoading: state.task.taskDetailsLoading,
  taskDetails: state.task.taskDetails,
  taskHistory: state.task.taskHistory,
  reassignAssigneeInfo: state.task.reassignAssigneeInfo,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getOrganizationMembersList: params => dispatch(getOrganizationMembersList(params)),
  getTaskDetails: params => dispatch(getTaskDetails(params)),
  getTaskType: params => dispatch(getTaskType(params)),
  updateTaskApproval: params => dispatch(updateTaskApproval(params)),
  editSubTask: params => dispatch(editSubTask(params)),
  updateTaskAssignee: params => dispatch(updateTaskAssignee(params)),
  removeTaskAssignee: params => dispatch(removeTaskAssignee(params)),
  updatePartialTask: params => dispatch(updatePartialTask(params)),
  getTaskHistory: params => dispatch(getTaskHistory(params)),
  reassignAssignee: params => dispatch(reassignAssignee(params)),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(TaskDetails);
